import React from 'react';
import { FiCheck, FiTrash2 } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

function HistoryPanel({ variants, selectedIds, onSelect, onClear }) {
  return (
    <section className="history">
      <div className="section-heading">
        <div>
          <span>ARHIVĂ SESIUNE</span>
          <h2>ISTORIC & COMPARAȚIE</h2>
        </div>
        <button type="button" onClick={onClear} disabled={!variants.length}>
          <SafeIcon icon={FiTrash2} />
          GOLEȘTE
        </button>
      </div>

      {!variants.length ? (
        <p className="empty-state">
          Generează un lot pentru a compara automat variantele.
        </p>
      ) : (
        <div className="history-table-wrap">
          <table className="history-table">
            <thead>
              <tr>
                <th>SELECTAT</th>
                <th>VARIANTĂ</th>
                <th>NUMERE</th>
                <th>DISTRIBUȚIE</th>
                <th>ALGORITMIC</th>
              </tr>
            </thead>
            <tbody>
              {variants.map((variant, index) => {
                const selected = selectedIds.includes(variant.id);

                return (
                  <tr className={selected ? 'is-selected' : ''} key={variant.id}>
                    <td>
                      <button
                        className="select-variant"
                        type="button"
                        aria-pressed={selected}
                        onClick={() => onSelect(variant.id)}
                      >
                        {selected && <SafeIcon icon={FiCheck} />}
                      </button>
                    </td>
                    <td>#{String(index + 1).padStart(2, '0')}</td>
                    <td>
                      <div className="compact-numbers">
                        {variant.numbers.map((number) => (
                          <b key={number}>
                            {String(number).padStart(2, '0')}
                          </b>
                        ))}
                      </div>
                    </td>
                    <td>{variant.distributionScore}%</td>
                    <td><strong>{variant.confidenceScore}%</strong></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

export default HistoryPanel;